<template>
  <div class="app-wrap">
    <div class="app-header"></div>
    <div class="container">

    <div v-if="isLoading" class="se-pre-con"></div>
    <!-- <img alt="Gomobile logo" src="@/assets/logo.svg" class="company-logo" /> -->
    <form v-if="!showThanks" action="#">
      <div class="paragraph-wrap">
        <h1 class="text-bold text-primary no-top-margin">
          NPS Go Mobile
        </h1>
        <div class="welcome-text">
          <p class="paragraph">Дорогие партнёры!</p>
          <p class="paragraph">Мы искренне ценим наше сотрудничество и стремимся к его постоянному развитию и улучшению. Для того чтобы сделать наше взаимодействие ещё более продуктивным и взаимовыгодным, нам очень важна ваша обратная связь.</p>
          <p class="paragraph">Просим вас уделить несколько минут и пройти короткий опрос ниже. Это займет не более 5 минут, но поможет нам лучше понять ваши ожидания и сделать совместную работу ещё более эффективной.</p>
          <p class="paragraph">Заранее благодарим за ваше время и участие!</p>
        </div>
        <div class="rating-legend" v-if="false">
          <h3 class="text-bold">Легенда оценок</h3>
          <div class="legend-items">
            <div class="legend-group green">
              <div class="legend-item">
                <span class="rating">10</span>
                <span class="description">Исключительный уровень: значительно и стабильно превосходит ожидания</span>
              </div>
              <div class="legend-item">
                <span class="rating">9</span>
                <span class="description">Отличный уровень: стабильно соответствует ожиданиям</span>
              </div>
            </div>
            <div class="legend-group yellow">
              <div class="legend-item">
                <span class="rating">8</span>
                <span class="description">Хороший уровень: стабильно соответствует ожиданиям</span>
              </div>
              <div class="legend-item">
                <span class="rating">7</span>
                <span class="description">Стандартный уровень: стабильно соответствует ожиданиям</span>
              </div>
              <div class="legend-item">
                <span class="rating">6</span>
                <span class="description">Стандартный уровень: в большинстве случаев соответствует ожиданиям</span>
              </div>
            </div>
            <div class="legend-group red">
              <div class="legend-item">
                <span class="rating">5</span>
                <span class="description">Удовлетворительно</span>
              </div>
              <div class="legend-item">
                <span class="rating">3-4</span>
                <span class="description">Низкий уровень: ожидания чаще не выполняются</span>
              </div>
              <div class="legend-item">
                <span class="rating">0-2</span>
                <span class="description">Неудовлетворительный уровень: не соответствует ожиданиям совсем</span>
              </div>
            </div>
          </div>
        </div>
        <div class="personal-info">
          <div class="form-group">
            <h2 class="text-bold text-primary">Укажите ваше имя и фамилию<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('name.comment') && 'must-answer',
              ]"
              v-model="form.name.comment"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Иванов Иван Иванович"
            />
            <div v-if="isMissing('name.comment')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Укажите вашу компанию и должность<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('company.comment') && 'must-answer',
              ]"
              v-model="form.company.comment"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Название компании, должность"
            />
            <div v-if="isMissing('company.comment')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Укажите ваш e-mail<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('email.comment') && 'must-answer',
              ]"
              v-model="form.email.comment"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="example@mail.com"
              :validate-email="true"
              @emailValidation="handleEmailValidation"
            />
            <div v-if="isMissing('email.comment')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>

        <div class="departments-rating">
          <div class="form-group">
            <h2 class="text-bold text-primary">Как вы оцениваете уровень профессиональной экспертизы отдела Partnership?<span class="danger">*</span></h2>
            <ThePointsbar
              :size="10"
              code="partnership"
              :full-name="true"
              :alert-line="isMissing('departments.partnership')"
              @change="saveRating('departments', 'partnership', $event)"
            />
            <div v-if="isMissing('departments.partnership')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Как вы оцениваете уровень профессиональной экспертизы отдела Buying?<span class="danger">*</span></h2>
            <ThePointsbar
              :size="10"
              code="buying"
              :full-name="true"
              :alert-line="isMissing('departments.buying')"
              @change="saveRating('departments', 'buying', $event)"
            />
            <div v-if="isMissing('departments.buying')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group" v-if="false">
            <h2 class="text-bold text-primary">Как вы оцениваете уровень профессиональной экспертизы отдела Planning?<span class="danger">*</span></h2>
            <ThePointsbar
              :size="10"
              code="planning"
              :full-name="true"
              :alert-line="isMissing('departments.planning')"
              @change="saveRating('departments', 'planning', $event)"
            />
            <div v-if="isMissing('departments.planning')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>
        <div class="buying-section">
          <h2 class="text-bold text-primary section-header">Buying</h2>
          
          <div class="form-group">
            <h2 class="text-bold text-primary">С кем из команды вы чаще всего взаимодействуете?</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('buying.teamInteraction') && 'must-answer',
              ]"
              v-model="form.buying.teamInteraction"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Укажите имена сотрудников, с которыми вы чаще всего контактируете"
            />
            <div v-if="isMissing('buying.teamInteraction')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Как вы оцениваете оперативность ответов на вопросы? (общая оценка)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - никогда не отвечают, 10 - всегда на связи</p>
            <ThePointsbar
              :size="10"
              code="responseSpeed"
              :full-name="true"
              :alert-line="isMissing('buying.responseSpeed')"
              @change="saveRating('buying', 'responseSpeed', $event)"
              
            />
            <div v-if="isMissing('buying.responseSpeed')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Оцените проактивность команды (с точки зрения предложений по оптимизации кампаний, добавления сегментов, креативам и т.д.)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - никогда ничего не предлагают сами, 10 - выходят сами с предложениями</p>
            <ThePointsbar
              :size="10"
              code="proactivity"
              :full-name="true"
              :alert-line="isMissing('buying.proactivity')"
              @change="saveRating('buying', 'proactivity', $event)"
              
            />
            <div v-if="isMissing('buying.proactivity')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Оцените пунктуальность команды (с точки зрения соблюдения договоренностей по срокам предоставления информации, отчётов и т.д.)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - срывают сроки, 10 - всегда пунктуальны</p>
            <ThePointsbar
              :size="10"
              code="punctuality"
              :full-name="true"
              :alert-line="isMissing('buying.punctuality')"
              @change="saveRating('buying', 'punctuality', $event)"
              
            />
            <div v-if="isMissing('buying.punctuality')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Есть ли данные, которые мы не предоставляем, но они вам нужны для оптимизации результатов кампаний?</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('buying.missingData') && 'must-answer',
              ]"
              v-model="form.buying.missingData"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Опишите, каких данных вам не хватает"
            />
            <div v-if="isMissing('buying.missingData')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Насколько часто ваши предложения реализовываются командой? (например, по новым форматам размещения)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - никогда не рассматриваются, 10 - охотно предлагают клиентам</p>
            <ThePointsbar
              :size="10"
              code="proposalsImplementation"
              :full-name="true"
              :alert-line="isMissing('buying.proposalsImplementation')"
              @change="saveRating('buying', 'proposalsImplementation', $event)"
              
            />
            <div v-if="isMissing('buying.proposalsImplementation')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Что вам не хватает в работе с командой Buying?<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('buying.whatsMissing') && 'must-answer',
              ]"
              v-model="form.buying.whatsMissing"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Опишите, чего вам не хватает в работе с командой"
            />
            <div v-if="isMissing('buying.whatsMissing')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Что бы вы хотели улучшить в работе с командой? Ваши любые предложения<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('buying.improvements') && 'must-answer',
              ]"
              v-model="form.buying.improvements"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Поделитесь вашими предложениями по улучшению работы"
            />
            <div v-if="isMissing('buying.improvements')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>
      

        <div class="partnership-section section-block">
          <h2 class="text-bold text-primary section-header">Partnership</h2>
          <div class="form-group">
            <h2 class="text-bold text-primary">С кем из команды вы чаще всего взаимодействуете?<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('partnership.teamInteraction') && 'must-answer',
              ]"
              v-model="form.partnership.teamInteraction"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Укажите имена сотрудников, с которыми вы чаще всего контактируете"
            />
            <div v-if="isMissing('partnership.teamInteraction')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Как вы оцениваете оперативность ответов на вопросы? (общая оценка)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - никогда не отвечают, 10 - всегда на связи</p>
            <ThePointsbar
              :size="10"
              code="responseSpeed"
              :full-name="true"
              :alert-line="isMissing('partnership.responseSpeed')"
              @change="saveRating('partnership', 'responseSpeed', $event)"
              
            />
            <div v-if="isMissing('partnership.responseSpeed')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Оцените пунктуальность команды (с точки зрения соблюдения договоренностей по срокам подписания договоров, ДС, отчётности и т.д.)<span class="danger">*</span></h2>
            <p class="rating-description">где 0 - срывают сроки, 10 - всегда пунктуальны</p>
            <ThePointsbar
              :size="10"
              code="punctuality"
              :full-name="true"
              :alert-line="isMissing('partnership.punctuality')"
              @change="saveRating('partnership', 'punctuality', $event)"
              
            />
            <div v-if="isMissing('partnership.punctuality')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Что вам не хватает в работе с командой Partnership?<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('partnership.whatsMissing') && 'must-answer',
              ]"
              v-model="form.partnership.whatsMissing"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Опишите, чего вам не хватает в работе с командой"
            />
            <div v-if="isMissing('partnership.whatsMissing')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Что бы вы хотели улучшить в работе с командой? Ваши любые предложения<span class="danger">*</span></h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('partnership.improvements') && 'must-answer',
              ]"
              v-model="form.partnership.improvements"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Поделитесь вашими предложениями по улучшению работы"
            />
            <div v-if="isMissing('partnership.improvements')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>

        <div class="planning-section section-block" v-if="false">
          <h2 class="text-bold text-primary section-header">Planning</h2>
          
          <div class="form-group">
            <h2 class="text-bold text-primary">С кем из команды вы чаще всего взаимодействуете?<span class="danger">*</span></h2>
            
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  v-model="form.planning.noInteraction"
                  @change="onPlanningInteractionChange"
                />
                <span class="checkmark-custom"></span>
                Ни с кем из команды не взаимодействую
              </label>
            </div>
            
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('planning.teamInteraction') && 'must-answer',
              ]"
              v-model="form.planning.teamInteraction"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Укажите имена сотрудников, с которыми вы чаще всего контактируете"
              :disabled="form.planning.noInteraction"
            />
            
            <div v-if="isMissing('planning.teamInteraction')" class="validation-message">
              Пожалуйста, заполните это поле или выберите "Ни с кем не взаимодействую"
            </div>
            
            <!-- <div v-if="form.planning.noInteraction" class="info-message">
              ✓ Вы указали, что не взаимодействуете с командой Planning. Остальные вопросы этого блока стали необязательными.
            </div> -->
          </div>

          <div class="form-group" v-if="!form.planning.noInteraction">
            <h2 class="text-bold text-primary">Как вы оцениваете оперативность ответов на вопросы? (общая оценка)</h2>
            <p class="rating-description">где 0 - никогда не отвечают, 10 - всегда на связи</p>
            <ThePointsbar
              :size="10"
              code="responseSpeed"
              :full-name="true"
              :alert-line="isMissing('planning.responseSpeed')"
              @change="saveRating('planning', 'responseSpeed', $event)"
              
            />
            <div v-if="isMissing('planning.responseSpeed')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group" v-if="!form.planning.noInteraction">
            <h2 class="text-bold text-primary">Насколько часто ваши предложения реализовываются командой? (например, по новым форматам размещения)</h2>
            <p class="rating-description">где 0 - никогда не рассматриваются, 10 - охотно предлагают клиентам</p>
            <ThePointsbar
              :size="10"
              code="proposalsImplementation"
              :full-name="true"
              :alert-line="isMissing('planning.proposalsImplementation')"
              @change="saveRating('planning', 'proposalsImplementation', $event)"
              
            />
            <div v-if="isMissing('planning.proposalsImplementation')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group" v-if="!form.planning.noInteraction">
            <h2 class="text-bold text-primary">Что вам не хватает в работе с командой Planning?</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('planning.whatsMissing') && 'must-answer',
              ]"
              v-model="form.planning.whatsMissing"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Опишите, чего вам не хватает в работе с командой"
            />
            <div v-if="isMissing('planning.whatsMissing')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group" v-if="!form.planning.noInteraction">
            <h2 class="text-bold text-primary">Что бы вы хотели улучшить в работе с командой? Ваши любые предложения</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('planning.improvements') && 'must-answer',
              ]"
              v-model="form.planning.improvements"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Поделитесь вашими предложениями по улучшению работы"
            />
            <div v-if="isMissing('planning.improvements')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>

        <div class="general-section section-block">
          <h2 class="text-bold text-primary section-header">Общие вопросы</h2>
          
          <div class="form-group">
            <h2 class="text-bold text-primary">Что вам не хватает в работе с Go Mobile?</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('general.whatsMissing') && 'must-answer',
              ]"
              v-model="form.general.whatsMissing"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Опишите, чего вам не хватает в работе с компанией"
            />
            <div v-if="isMissing('general.whatsMissing')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>

          <div class="form-group">
            <h2 class="text-bold text-primary">Что бы вы хотели улучшить?</h2>
            <TextareaAutosize
              :class="[
                screenWidth > 768
                  ? 'feedback-textarea desktop-textarea'
                  : 'feedback-textarea',
                isMissing('general.improvements') && 'must-answer',
              ]"
              v-model="form.general.improvements"
              type="text"
              :min-height="10"
              :max-height="350"
              placeholder="Поделитесь вашими предложениями по улучшению работы"
            />
            <div v-if="isMissing('general.improvements')" class="validation-message">
              Пожалуйста, заполните это поле
            </div>
          </div>
        </div>
      
      </div>

      <button type="button" class="submit-button" @click="sendFeedback">
        <span>Отправить</span
        ><img src="@/assets/message.svg" />
      </button>
    </form>
    <div v-else class="thanks-text">
      <h1>Спасибо за вашу обратную связь!</h1>
      <p>
        Задачи по оптимизации уже поставлены в наш таск-менеджер :)
        <!-- Если хотите предметнее обсудить в чем мы еще можем быть ваши полезны - напишите на нашу общую почту (<a
          class="enable-select"
          href="mailto:resell@gomobile.ru"
          >resell@gomobile.ru</a
        >) или напрямую аккаунт директору Лизе Соколовой (<a
          class="enable-select"
          href="mailto:sokolova@gomobile.ru"
          >sokolova@gomobile.ru</a
        >). -->
      </p>
    </div>
    </div>
  </div>
</template>

<script>
import ThePointsbar from "@/components/ThePointsbar";
import TextareaAutosize from "@/components/TextareaAutosize.vue";
import API from "@/api";

export default {
  name: "App",
  components: {
    ThePointsbar,
    TextareaAutosize,
  },
  data: function () {
    return {
      missingFields: [],
      requiredFields: [
        // Персональные данные
        "name.comment",
        "company.comment",
        "email.comment",
        
        // Оценка отделов
        "departments.partnership",
        "departments.buying",
       // "departments.planning",
        
        // Секция Planning
        // "planning.teamInteraction",
        // "planning.responseSpeed",
        // "planning.proposalsImplementation", 
        // "planning.whatsMissing",
        // "planning.improvements",
        
        // Секция Partnership
        "partnership.teamInteraction",
        "partnership.responseSpeed",
        "partnership.punctuality",
        "partnership.whatsMissing",
        "partnership.improvements",
        
        // Секция Buying
        "buying.responseSpeed",
        "buying.proactivity",
        "buying.punctuality",
        "buying.proposalsImplementation",
        "buying.whatsMissing",
        "buying.improvements",
        
        // Общие вопросы
        // "general.whatsMissing",
        // "general.improvements",
        
      ],
      otherHowFound: "",
      showThanks: false,
      isLoading: false,
      isAlert: false,
      feedbackData: {
        table: "simple",
        version: "v2",
        name: "",
        isShort: false,
        fullRating: "",
        kpiRating: "",
        personalFeedback: "",
        commandRating: "",
        howFound: [],
        feedback: "",
      },
      isEmailValid: null, // null = not validated yet, true = valid, false = invalid
      form: {
        name: {
          comment: "",
        },
        company: {
          comment: "",
        },
        email: {
          comment: "",
        },
        departments: {
          partnership: null,
          buying: null,
          planning: null,
        },
        general: {
          whatsMissing: "",
          improvements: "",
        },
        planning: {
          teamInteraction: "",
          noInteraction: false,
          responseSpeed: null,
          proposalsImplementation: null,
          whatsMissing: "",
          improvements: "",
        },
        partnership: {
          teamInteraction: "",
          responseSpeed: null,
          punctuality: null,
          whatsMissing: "",
          improvements: "",
        },
        buying: {
          teamInteraction: "",
          responseSpeed: null,
          proactivity: null,
          punctuality: null,
          missingData: "",
          proposalsImplementation: null,
          whatsMissing: "",
          improvements: "",
        },
      },
    };
  },

  methods: {
    isEmpty(val) {
      return val === null || val === undefined || val === "";
    },
    validateForm() {
      // Создаем копию обязательных полей
      let fieldsToValidate = [...this.requiredFields];
      
      // Логика для Planning секции
      const hasPlanningInteraction = !this.isEmpty(this.form.planning.teamInteraction) || this.form.planning.noInteraction;
      
      if (!hasPlanningInteraction) {
        // Если ни текст, ни чекбокс не заполнены, оставляем только первый вопрос как обязательный
        fieldsToValidate = fieldsToValidate.filter(field => !field.startsWith('planning.') || field === 'planning.teamInteraction');
      } else if (this.form.planning.noInteraction) {
        // Если выбран чекбокс "ни с кем", убираем ВСЕ поля Planning из проверки
        fieldsToValidate = fieldsToValidate.filter(field => !field.startsWith('planning.'));
      } else {
        // Если есть текст во взаимодействии, убираем только первый вопрос из проверки
        // (остальные остаются обязательными)
        fieldsToValidate = fieldsToValidate.filter(field => field !== 'planning.teamInteraction');
      }
      
      this.missingFields = fieldsToValidate.filter((path) => {
        return this.isEmpty(
          path.split(".").reduce((o, k) => (o ? o[k] : undefined), this.form)
        );
      });
      
      console.log('this.missingFields',this.missingFields)
      
      // Additional check for email validity
      const isFormValid = this.missingFields.length === 0;
      const isEmailFieldFilled = !this.isEmpty(this.form.email.comment);
      const isEmailFormatValid = this.isEmailValid !== false;
      
      if (isEmailFieldFilled && !isEmailFormatValid) {
        console.log('Email format is invalid');
        return false;
      }
      
      return isFormValid;
    },
    isMissing(path) {
      return this.missingFields.includes(path);
    },
    handleEmailValidation(isValid) {
      this.isEmailValid = isValid;
      console.log('Email validation result:', isValid);
    },
    onPlanningInteractionChange() {
      if (this.form.planning.noInteraction) {
        // Если выбран "ни с кем", очищаем только остальные поля Planning (не teamInteraction)
        this.form.planning.responseSpeed = null;
        this.form.planning.proposalsImplementation = null;
        this.form.planning.whatsMissing = "";
        this.form.planning.improvements = "";
        
        // Убираем ошибки валидации для Planning полей из missingFields
        this.missingFields = this.missingFields.filter(field => !field.startsWith('planning.'));
      } else {
        // Если чекбокс снят, также очищаем ошибки Planning полей
        // Они будут пересчитаны при следующей валидации
        this.missingFields = this.missingFields.filter(field => !field.startsWith('planning.'));
      }
    },
    async sendFeedback() {
      if (!this.validateForm()) {
        this.$nextTick(() => {
          const first = this.$el.querySelector(".must-answer");
          if (first) {
            // first.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        });
        return;
      }
      const payload = {
        table: "simple",
        version: "v2",
        answers: this.form,
      };

      this.isLoading = true;
      try {
        const api = new API();
        await api.push(payload);
        this.showThanks = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }

    },

    addHowFound(val) {
      this.feedbackData.fullRating = val.text;
    },
    saveRating(section, question, value) {
      this.form[section][question] = value;
    },
    saveRadio(section, field, option) {
      this.form[section][field] = option;
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
    radioOptions() {
      return ["Да", "Нет"];
    },
  },
};
</script>



